'use client';

import Script from 'next/script'
import React from 'react'
import { logger } from '@/lib/logger';

const GTM_ID = 'GTM-PHZ7KSZ'

const GoogleTagManager = () => {
  return (
    <Script
      id="gtm-script"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          window.dataLayer = window.dataLayer || [];
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${GTM_ID}');
        `
      }}
      onLoad={() => {
        logger.log('[GTM] Script loaded successfully');
      }}
      onError={(error) => {
        logger.error('[GTM] Script failed to load:', error);
      }}
    />
  )
}

export default GoogleTagManager